class Spoiler {
    constructor(el) {
        this.spoiler = el;
        this.spoilerTitle = el.querySelector('.spoiler-title');
        this.spoilerToggle = this.spoilerTitle.querySelector('.spoiler-toggle');
        this.spoilerToggle.classList.remove('show-icon');
        this.spoilerToggle.classList.remove('hide-icon');
        this.visible = false;
        this.spoilerTitle.addEventListener('click', this.toggle.bind(this));
        this.spoilerContent = el.querySelector('.spoiler-content');
        // If in admin panel you close the spoiler tag, it will hide this element in DOM. We don't need that since
        // we have custom logic here.
        this.spoilerContent.style.display = null;
    }

    toggle() {
        if (!this.visible) {
            this.spoiler.classList.add('spoiler-open');
            this.visible = true;
        } else {
            this.spoiler.classList.remove('spoiler-open');
            this.visible = false;
        }
    }
}

export default Spoiler;
